/** Max length for meta name="description" (matches doctor fallback). */
export const META_DESC_MAX_LEN = 160;

/**
 * Plain text for meta / OG / Twitter description attributes: strip HTML tags,
 * normalize whitespace, trim length (same behavior as doctor-page fallback).
 */
export function stripHtmlForMeta(text, maxLen = META_DESC_MAX_LEN) {
  if (text == null || text === "") return "";
  const plain = String(text)
    .replace(/<[^>]*>/g, "")
    .replace(/\s+/g, " ")
    .trim();
  return maxLen > 0 ? plain.slice(0, maxLen) : plain;
}
